module.exports = __webpack_public_path__ + "img/notify-bell.c0bb732.svg";